export enum EditQuizStatus {
  Ok = 'Ok',
  Loading = 'Loading',
  Error = 'Error',
  Saving = 'Saving',
}
